import React from 'react';

/* ========================================================================= */
/* Component(s) */
/* ========================================================================= */

/**
 * @type {import('$types/components/partials/fields.d.ts').FloatingLabelInput}
 */
const FloatingLabelTextarea = (props) => {
    return (
        <div className='relative z-0 input-background rounded'>
            <textarea
                {...props}
                className='floating-label__input peer !h-[151px] resize-none w-full floating-label-focused placeholder-shown:py-10 placeholder-shown:md:py-10 focus:floating-label-focused'
                id={props.id}
                placeholder=' ' />

            <label
                className='floating-label__label peer-focus:start-0 peer-placeholder-shown:scale-100 peer-placeholder-shown:translate-y-0 peer-focus:scale-[0.8] peer-focus:-translate-y-[13px]'
                htmlFor={props.id}>
                {props.label}
            </label>
        </div>
    );
};

/* ========================================================================= */
/* Export(s) */
/* ========================================================================= */

export default FloatingLabelTextarea;
